import { Component, Input, OnInit } from '@angular/core';
import { WidgetComponent } from '@widgets/widgets';
import { StudentCourse } from '@widgets/models/StudentCourse';

@Component({
  selector: 'lms-course-students',
  templateUrl: './student-course.component.html',
  styleUrls: ['./student-course.component.scss']
})
export class StudentCourseComponent implements WidgetComponent, OnInit {
  @Input() public data: any;
  public studentCourses: StudentCourse[] = [];

  constructor() {}

  public ngOnInit(): void {
    this.studentCourses = this.data['studentCourses'];
  }

  public trackByStudentCourse(index: number, studentCourse: any): string {
    return studentCourse ? studentCourse.courseId : null;
  }
}
